import './allDrivers.css';
import DriversFilter from "./driversFilter/driversFilter";
import DriverList from "./driverList/driverList";
import Pagination from "../../../shared/pagination/pagination";
const AllDrivers = () => {
    return(
        <div className={'driver-section flex gap-0 align-top hr-space-between'}>
            <div className="page-filter-sec">
                <DriversFilter/>
            </div>
            <div className={'driver-table'}>
                <div className="margin-b-30">
                    <div className="search-box drivers-search width-block-100 margin-b-30 round-corner-8">
                        <input type="text" placeholder={'Search'}/>
                    </div>
                    <div className="sf-medium font-18">List View</div>
                </div>
                <div className="margin-b-50"><DriverList/></div>
                <div className=""><Pagination/></div>

            </div>
        </div>
    )
}

export default AllDrivers;
